import { render, staticRenderFns } from "./Against.vue?vue&type=template&id=9f14d9cc&scoped=true&"
import script from "./Against.vue?vue&type=script&lang=js&"
export * from "./Against.vue?vue&type=script&lang=js&"
import style0 from "./Against.vue?vue&type=style&index=0&id=9f14d9cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f14d9cc",
  null
  
)

export default component.exports